import React from "react";
import { Button } from "antd";
import { Plus } from "lucide-react";
import { Link } from "react-router-dom";

interface EmptyStateProps {
    icon: React.ReactNode;
    title: string;
    description: string;
    actionText?: string;
    actionLink?: string;
    onAction?: () => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({
    icon,
    title,
    description,
    actionText,
    actionLink,
    onAction
}) => {
    const actionButton = actionText && (
        <Button
            type="primary"
            size="large"
            icon={<Plus size={16} />}
            onClick={onAction}
        >
            {actionText}
        </Button>
    );

    return (
        <div className="empty-state">
            <div className="empty-state-icon">
                {icon}
            </div>
            <div className="empty-state-title">
                {title}
            </div>
            <div className="empty-state-description">
                {description}
            </div>
            {actionLink && actionButton ? (
                <Link to={actionLink}>{actionButton}</Link>
            ) : (
                actionButton
            )}
        </div>
    );
};

export default EmptyState;

